import { z } from 'zod';
import { isFieldText } from '~/components/FieldText';
import { isFieldTextarea } from '~/components/FieldTextarea';
import type { FieldsDisplayedSchema } from '~/shared/domain/models';

export interface FieldSchemas {
  stringSchema: z.ZodString;
  numberSchema: z.ZodNumber;
  arraySchema: z.ZodArray<z.ZodString, 'many'>;
}

export const generateCustomValidations = (field: FieldsDisplayedSchema): FieldSchemas => {
  let stringFieldSchema = z.string();
  let numberFieldSchema = z.number();
  let arrayFieldSchema = z.array(z.string());

  if (field.validations?.required) {
    stringFieldSchema = stringFieldSchema.min(1);
    arrayFieldSchema = arrayFieldSchema.min(1);
  }

  if (isFieldText(field) || isFieldTextarea(field)) {
    if (field.validations.minLength)
      stringFieldSchema = stringFieldSchema.min(field.validations.minLength);
    if (field.validations.maxLength)
      stringFieldSchema = stringFieldSchema.max(field.validations.maxLength);
  }

  if (isFieldText(field)) {
    if (field.validations.min) numberFieldSchema = numberFieldSchema.min(field.validations.min);
    if (field.validations.max) numberFieldSchema = numberFieldSchema.max(field.validations.max);
  }

  return {
    stringSchema: stringFieldSchema,
    numberSchema: numberFieldSchema,
    arraySchema: arrayFieldSchema,
  };
};
